import { filterDish } from './dishSearch';
import { toastError, toastSuccess } from '../utils/toastMessage';
import API from '../utils/API';
import { getDishes } from './dishes';

export const showEditRecepiePopup = (data) => {
  return {
    type: 'SHOW_EDIT_RECEPIE_POPUP',
    data,
  };
};

export const editDish = (data, newDish, payload) => {
  if (!payload) {
    payload = {
      name: '',
      calories: '',
      recepie: '',
      min_weight: '',
      avg_weight: '',
      max_weight: '',
      tags: [],
    };
  }
  return {
    type: 'EDIT_DISH',
    data,
    newDish,
    payload,
  };
};

export const cancelEditDish = () => {
  return {
    type: 'CANCEL_EDIT_DISH',
  };
};

export const editSelectedDishSuccess = (data) => {
  return {
    type: 'EDIT_SELECTED_DISH_SUCCESS',
    data,
  };
};

export const editSelectedDishError = (data) => {
  return {
    type: 'EDIT_SELECTED_DISH_ERROR',
    data,
  };
};

export const editDishCreateSuccess = (data) => {
  return {
    type: 'EDIT_DISH_CREATE_SUCCESS',
    data,
  };
};

export const createDish = (data) => {
  const fd = new FormData();
  fd.append('image', data.image);
  fd.append('dish', JSON.stringify(data));
  return (dispatch) => {
    API.post('/dishes', fd)
      .then((response) => {
        dispatch(editDishCreateSuccess(response.data.data.tags));
        dispatch(getDishes());
        dispatch(filterDish());
        toastSuccess('Блюдо успешно создано');
      })
      .catch(() => {
        toastError('В процессе сохранения возникли проблемы');
      });
  };
};

export const editSelectedDish = (data) => {
  const fd = new FormData();
  fd.append('image', data.image);
  fd.append('dish', JSON.stringify(data));
  return (dispatch, getState) => {
    const { currentDishesPage } = getState().dishSearch;
    const { searchParam, filterParam, sortParam, order } = getState().searchParams;
    API.post(`/dishes/${data.id}`, fd)
      .then((response) => {
        toastSuccess('Блюдо успешно обновлено');
        dispatch(editSelectedDishSuccess(response.data.data.tags));
        const sort = sortParam.slice(0, -1);
        dispatch(filterDish(searchParam, filterParam, sort, order, currentDishesPage, true));
      })
      .catch(() => {
        dispatch(editSelectedDishError());
        toastError('В процессе обновления возникли проблемы');
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/dishEdit.js